import React from "react";
import Colors from "../styles/Colors.json";
import config from "../configLoader";

interface SearchBarProps {
  placeholder: string; // Placeholder text for the search bar
  value: string; // Current value of the search input
  onChange: (value: string) => void; // Function to handle input changes
  style?: React.CSSProperties; // Optional custom styles
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void; // Optional key press handler
}

const SearchBar: React.FC<SearchBarProps> = ({ placeholder, value, onChange, style, onKeyPress }) => {
  // Extract maxWidth and minWidth from style if provided, otherwise use defaults
  const { maxWidth, minWidth, ...inputStyle } = style || {};
  const containerMaxWidth = maxWidth || "400px";
  const containerMinWidth = minWidth || undefined;
  
  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%", alignContent: "center" }}>
      <div
        style={{
          position: "relative",
          width: "100%",
          maxWidth: containerMaxWidth,
          minWidth: containerMinWidth,
        }}
      >
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={onKeyPress}
          style={{
            marginBottom: "0px",
            padding: "5px 0px 5px 10px", // Add padding on the right for the icon
            width: "100%",
            borderRadius: "10px",
            border: "0px solid rgb(111, 111, 111)",
            backgroundColor: config.secondaryColor,
            borderColor: config.primaryColor,
            ...inputStyle, // Apply remaining custom styles if provided
          }}
        />
      </div>
    </div>
  );
};

export default SearchBar;